<template>
    <div class="availability-preview text-center">
        <button class="btn btn-primary" @click="showModal = true">
            <IconSvg filepath="calendar.svg" class="mr-1" />
            <span class="align-middle">{{ $t('ProductDetails.availabilityPreview.previewButton') }}</span>
        </button>

        <ProductAvailabilityModal
            v-if="showModal"
            :product-id="productId"
            :selected-variant-id="selectedVariantId"
            @close="showModal = false"
        />
    </div>
</template>

<script>
import ProductAvailabilityModal from '@/components/modals/ProductAvailabilityModal.vue';

export default {
    name: 'availabilityPreview',
    components: { ProductAvailabilityModal },

    data() {
        return {
            showModal: false
        };
    },

    props: {
        productId: {
            type: [Number, String],
            required: true
        },

        selectedVariantId: {
            type: [Number, String]
        }
    }
};
</script>

<style scoped lang="scss"></style>
